// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"d0589b8d","145":"69afa4e0","969":"17029516"}[chunkId] + ".chunk.js";
};